import axios from "axios";
import authHeader from "./auth-header";
import Config from "../config/index";

class ThemeTypographyService {
    getThemeProperty() {
        return axios.get(Config.apiBasePath + "/theme/getThemeProperty", {
            headers: {
                ...authHeader(),
            },
        });
    }

    getAllEmailTemplates() {
        return axios.get(Config.apiBasePath + "/getAllEmailTemp", {
            headers: {
                ...authHeader(),
            },
        });
    }


    getEmailThemeProperty(data) {
        return axios.get(Config.apiBasePath + "/getEmailTempProperty/" + data, {
            headers: {
                ...authHeader(),
            },
        });
    }

    getEmailType() {
        return axios.get(Config.apiBasePath + "/getEmailTempType", {
            headers: {
                ...authHeader(),
            },
        });
    }

    saveTypography(data) {
        return axios.post(Config.apiBasePath + "/theme/typography", data, {
            headers: {
                ...authHeader(),
            },
        });
    }

    updateEmailTemplate(data) {
        return axios.post(Config.apiBasePath + "/updateEmailTempProperty", data, {
            headers: {
                ...authHeader(),
            },
        });
    }

    saveEmailTemplate(data) {
        return axios.post(Config.apiBasePath + "/saveEmailTemp", data, {
            headers: {
                ...authHeader(),
            },
        });
    }

    async getTypography() {
        return await axios.get(Config.apiBasePath + "/theme/getTypography", {
            headers: {
                ...authHeader(),
            },
        });
    }
}

export default new ThemeTypographyService();
